<div appPreventScroll class="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 sm:p-0">
    <div
        class="bg-white rounded-2xl shadow-xl w-full max-w-[400px] p-6 lg:p-8 relative overflow-hidden flex flex-col items-center">

        <div class="overflow-y-auto custom-scroll sm:max-h-[calc(100vh-200px)]">
            <!-- Icon Circle -->
            <div class="w-full bg-primary-50 rounded-full flex items-center justify-center mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-primary-600" fill="none" viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                </svg>
            </div>

            <!-- Content -->
            <div class="text-center mb-8">
                <h3 class="text-xl font-bold text-gray-900 mb-2">{{ 'header.confirm_modal.title' | translate }}</h3>
                <p class="text-sm text-gray-500">
                    {{ 'header.confirm_modal.message' | translate: { language: selectedLanguageName } }}
                </p>
            </div>
        </div>

        <!-- Buttons -->
        <div class="flex gap-4 w-full justify-center">
            <button type="button" (click)="cancel.emit()"
                class="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none transition-all cursor-pointer">
                {{ 'header.confirm_modal.cancel' | translate }}
            </button>
            <button type="button" (click)="confirm.emit()"
                class="w-full sm:w-auto px-6 py-2.5 text-sm font-semibold text-white bg-[#6e52fe] hover:bg-[#000000] cursor-pointer rounded-lg focus:outline-none transition-all shadow-sm">
                {{ 'header.confirm_modal.confirm' | translate }}
            </button>
        </div>

    </div>
</div>